import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import EgresarLicenciaComponent from "../licenciaCard/egresarLicencia";
import CargarFotoLicencia from "../licenciaCard/cargarFoto";
import TakeFotoToUpdate from "../licenciaCard/takeFotoToUpdate";
import VerEgresoLicenciaComponent from "../licenciaCard/verEgresoLicencia";
import Button from "../../../components/button";

function LicenciaFoundComponent() {

    const licenciaFound = useSelector((state) => state.licenciaFound);
    const tipoCurrentUser = useSelector((state) => state.tipoCurrentUser);


//-------------------Estado actual------------------------//
  const [estado, setEstado] = useState("");

  useEffect(() => {
    if (licenciaFound?.egresada !== null) {
      setEstado("Egresada")
    } else {
      setEstado("Ingresada")
    }
  }, [licenciaFound]);




    const [isEgresarLicenciaOpen, setIsEgresarLicenciaOpen] = useState(false);

    const openModalEgresoLicencia = () => setIsEgresarLicenciaOpen(true);
    const closeModalEgresoLicencia = () => setIsEgresarLicenciaOpen(false);

    const [isVerEgresoLicenciaOpen, setIsVerEgresoLicenciaOpen] = useState(false);

    const openModalVerEgresoLicencia = () => setIsVerEgresoLicenciaOpen(true);
    const closeModalVerEgresoLicencia = () => setIsVerEgresoLicenciaOpen(false);

    const [isCargarFotoOpen, setIsCargarFotoOpen] = useState(false);

    const openCargarFoto = () => setIsCargarFotoOpen(true);
    const closeCargarFoto = () => setIsCargarFotoOpen(false);

    const [isTakeFotoToUpdateOpen, setIsTakeFotoToUpdateOpen] = useState(false);

    const openTakeFotoToUpdate = () => {
        setIsTakeFotoToUpdateOpen(true);
        closeCargarFoto()
    };
    const closeTakeFotoToUpdate = () => setIsTakeFotoToUpdateOpen(false);

    // Foto
    const env = process.env.REACT_APP_ENVIRONMENT || "development";

    // Directorios según el entorno
    const remoteDir = env === "production" ? "images/corralon/production/fotos_licencias" : "images/corralon/stage/fotos_licencias";

    const urlFoto = `https://staticcontent.sannicolasciudad.gob.ar/${remoteDir}/${licenciaFound?.foto}`;


    return (
        <div>
            {/* Render condicional para egresar licencia */}
            {isEgresarLicenciaOpen && <EgresarLicenciaComponent closeModalEgresoLicencia={closeModalEgresoLicencia} dni={licenciaFound.dni} observaciones={licenciaFound.observaciones} id={licenciaFound.id} />}

            {/* Render condicional para ver egreso de licencia */}
            {isVerEgresoLicenciaOpen && <VerEgresoLicenciaComponent closeModalVerEgresoLicencia={closeModalVerEgresoLicencia} idLicencia={licenciaFound.id} />}

            {/* Render condicional para cargar foto */}
            {isCargarFotoOpen && <CargarFotoLicencia closeCargarFoto={closeCargarFoto} openTakeFotoToUpdate={openTakeFotoToUpdate} id={licenciaFound.id} />}

            {/* Render condicional para tomar foto */}
            {isTakeFotoToUpdateOpen && <TakeFotoToUpdate closeTakeFotoToUpdate={closeTakeFotoToUpdate} id={licenciaFound.dni}/* dni={dni} observaciones={observaciones} id={id} */ />}

            {licenciaFound !== null && (
                <div>
                    Licencia encontrada:
                    <div
                        className="flex overflow-hidden border-[0.5px] items-center bg-white border-[#0477ad] gap-1 pr-1 p-3 rounded-lg shadow-[1px_2px_8px_1px_rgba(219,219,219,0.45)] flex-row md:max-w-xl"
                    >
                        <div className="w-full md:w-1/2 h-full">
                            {licenciaFound.foto ? (

                                <img
                                    className="object-cover w-full h-full rounded-l-lg md:rounded-none md:rounded-s-lg"
                                    src={urlFoto}
                                    alt="foto licencia"
                                />
                            ) : (
                                <button
                                    onClick={openCargarFoto}
                                    disabled={tipoCurrentUser === "viewer"}
                                    className={`text-[#0477AD] border-[#0477AD] text-[1.5rem] font-bold font-inter justify-center flex text-center items-center border w-auto h-full rounded
                                    ${tipoCurrentUser === "viewer" ? "text-gray-400 border-gray-400 cursor-not-allowed" : ""
                                        }`}
                                >Cargar foto
                                </button>

                            )}
                        </div>
                        <div className="flex flex-col justify-between px-2 leading-normal gap-1.5">
                            <div className="gap-1">
                                <div className="self-stretch text-[#687073] text-[14px] font-inter font-medium break-words">
                                    DNI: {licenciaFound.dni}
                                </div>
                                <div className="self-stretch text-[#687073] text-[14px] font-inter font-medium break-words">
                                    Nombre: {licenciaFound.nombre}
                                </div>
                                <div className="self-stretch text-[#687073] text-[14px] font-inter font-medium break-words">
                                    Fecha Hora: {licenciaFound.fecha_hora}
                                </div>
                                <div className="self-stretch text-[#687073] text-[14px] font-inter font-medium break-words">
                                    Estado: {estado}
                                </div>
                            </div>

                            <div className="justify-end flex">
                                {estado === "Ingresada" ? (
                                    <Button
                                        size="sm"
                                        disabled={tipoCurrentUser === "viewer"}
                                        onClick={openModalEgresoLicencia}
                                        className="w-[6rem] h-[2rem]"
                                    >
                                        Egresar
                                    </Button>
                                ) : (
                                    <div className="justify-end flex">
                                        <button
                                            onClick={openModalVerEgresoLicencia}
                                            className="inline-flex w-[8rem] h-[2rem] px-[18px] py-[13px] bg-gray-700 rounded-lg justify-center items-center gap-1 text-[#f6f5f5] text-base font-semibold font-inter"
                                        >
                                            Ver egreso
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>

    );
}

export default LicenciaFoundComponent;
